import React, { Fragment } from "react";
import ReactPaginate from "react-paginate";
import AccessLogTableView from "../components/AccessLogTableView";
import StudentController from "../api/StudentController";

interface AccessLogViewState
{
    currentPage: number;
    pageTotal: number;
    offset: number;
    logs: any;
}

interface AccessLogViewProps
{
    data: any;
}

export default class AccessLogView extends React.Component<AccessLogViewProps, AccessLogViewState>
{
    studentController: StudentController;

    constructor(props: any) 
    {
        super(props);
        this.studentController = new StudentController();

        let pageNumber = 1;
        let logs = null;

        //null check
        if (this.props.data.logRecords)
        {
            pageNumber = Math.ceil(this.props.data.logRecords.length / 8);
            logs = this.props.data.logRecords.slice(0, 8);
        }

        if (pageNumber == 1)
            pageNumber = 0;

        this.state = {
            currentPage: 1,
            pageTotal: pageNumber,
            offset: 0,
            logs: logs
        };
    }

    onChange = (page: any): void =>
    {
        const offset = Math.ceil(page.selected * 8);

        const data = this.props.data.logRecords;

        const sliceData = data.slice(offset, offset + 8);
        this.setState({
            currentPage: page.selected,
            offset: offset,
            logs: sliceData
        });
    }

    render(): React.ReactNode 
    {
        return <Fragment>
            <AccessLogTableView data={this.state.logs} offset={this.state.offset} />
            <ReactPaginate
                previousLabel={""}
                nextLabel={""}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={this.state.pageTotal}
                marginPagesDisplayed={2}
                pageRangeDisplayed={2}
                onPageChange={this.onChange}
                containerClassName={"pagination"}
                pageLinkClassName={"page-link"}
                pageClassName={"page-item"}
                activeClassName={"active"}
            />
        </Fragment>;
    }
}